export default 'Start typing and select a city'
